import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'queuegroup',
  entityPlural: 'queuegroups',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV,
  state: {
    publishable: false
  }
});
